import { render, staticRenderFns } from "./ItemResponse.vue?vue&type=template&id=53c66c81&scoped=true&"
import script from "./ItemResponse.vue?vue&type=script&lang=js&"
export * from "./ItemResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c66c81",
  null
  
)

export default component.exports